import useApp from "../store/app/appContext";
import { useHistory } from "react-router";

export const useNotifications = (notificationType) => {

  const {
    appState: { user },
    sendVerificationEmail,
  } = useApp();

  const history = useHistory();

  const notificationList = {
    verifyEmail: {
      body: "You haven't verified your email yet. Verify your account now.",
      button: 'Send a new verification email',
      onClick: () => sendVerificationEmail(user.email)
    },
    scheduleScanAndGo: {
      body: "You haven't scheduled your first Scan & Go yet. Schedule one to obtain your digital scans.",
      button: 'Schedule one now',
      onClick: () => alert('I will render a scheduling popup')
    },
    completeMedicalQuestionnaire: {
      body: "Your medical questionnaire is not complete.",
      button: 'Complete it now',
      onClick: () => history.push('/account?medical-questionnaire=true')
    }
  }

  return notificationList[notificationType]
};
